import { render, staticRenderFns } from "./DataAsset.vue?vue&type=template&id=3616963f"
import script from "./DataAsset.vue?vue&type=script&lang=js"
export * from "./DataAsset.vue?vue&type=script&lang=js"
import style0 from "./DataAsset.vue?vue&type=style&index=0&id=3616963f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports